import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';

import { NamedLink } from '../../../../components';

import lauraPhoto from './photos/laura.png';
import olenaPhoto from './photos/olena.png';
import sheelonPhoto from './photos/sheelon.png';

import css from './Founders.module.css';

const people = [
  {
    id: 'laura',
    photo: lauraPhoto,
    photoClassName: css.laura,
    nameId: 'ForProvidersFounders.lauraName',
    name: 'Laura Groppe',
    roleId: 'ForProvidersFounders.lauraRole',
    role: 'Founder & CEO',
    credentialsId: 'ForProvidersFounders.lauraCredentials',
    credentials: 'Entrepreneur and mother of 2',
  },
  {
    id: 'olena',
    photo: olenaPhoto,
    photoClassName: css.olena,
    nameId: 'ForProvidersFounders.olenaName',
    name: 'Olena Dobczansky',
    roleId: 'ForProvidersFounders.olenaRole',
    role: 'Clinical advisor',
    credentialsId: 'ForProvidersFounders.olenaCredentials',
    credentials: 'MSN, RNC-MNN, IBCLC, C-ONQS, LCCE and mother of 2',
  },
  {
    id: 'sheelon',
    photo: sheelonPhoto,
    photoClassName: css.sheelon,
    nameId: 'ForProvidersFounders.sheelonName',
    name: 'Sheelon Aghili',
    roleId: 'ForProvidersFounders.sheelonRole',
    role: 'Medical advisor',
    credentialsId: 'ForProvidersFounders.sheelonCredentials',
    credentials: 'PA-C, Gynecology',
  },
];

/**
 * The clinicians behind PostPartners, with a link to the full about page.
 */
const Founders = () => (
  <section className={css.root}>
    <div className={css.inner}>
      <div className={css.copy}>
        <p className={css.eyebrow}>
          <FormattedMessage
            id="ForProvidersFounders.eyebrow"
            defaultMessage="Who's behind PostPartners"
          />
        </p>
        <h2 className={css.title}>
          <FormattedMessage
            id="ForProvidersFounders.title"
            defaultMessage="Guided by clinicians<line>from <accent>day one.</accent></line>"
            values={{
              line: chunks => <span className={css.titleLine}>{chunks}</span>,
              accent: chunks => <em className={css.accent}>{chunks}</em>,
            }}
          />
        </h2>
        <p className={css.text}>
          <FormattedMessage
            id="ForProvidersFounders.intro"
            defaultMessage="Perinatal clinicians have helped shape PostPartners since the beginning."
          />
        </p>
      </div>
      <blockquote className={css.quoteBlock}>
        <span className={css.quoteMark} aria-hidden="true">
          “
        </span>
        <p className={css.quote}>
          <FormattedMessage
            id="ForProvidersFounders.quote"
            defaultMessage="Providers are the heart of postpartum care. We built PostPartners so the families who need you can actually find you."
          />
        </p>
        <p className={css.attribution}>
          <FormattedMessage
            id="ForProvidersFounders.attribution"
            defaultMessage="Laura Groppe, Founder & CEO"
          />
        </p>
      </blockquote>
      <ul className={css.list}>
        {people.map(person => (
          <li key={person.id} className={css.person}>
            <img className={person.photoClassName} src={person.photo} alt="" />
            <div>
              <p className={css.role}>
                <FormattedMessage id={person.roleId} defaultMessage={person.role} />
              </p>
              <h3 className={css.name}>
                <FormattedMessage id={person.nameId} defaultMessage={person.name} />
              </h3>
              <p className={css.credentials}>
                <FormattedMessage id={person.credentialsId} defaultMessage={person.credentials} />
              </p>
            </div>
          </li>
        ))}
      </ul>
      <NamedLink className={css.link} name="CMSPage" params={{ pageId: 'about' }}>
        <FormattedMessage id="ForProvidersFounders.link" defaultMessage="About us" />
        <span aria-hidden="true"> →</span>
      </NamedLink>
    </div>
  </section>
);

export default Founders;
